<template lang="pug">
div.index
    div.top-nav1
    div.top-nav
        Icon(type="md-arrow-back",@click='gotoback1').icon-back
        div.nav-center
            ul
                li(v-for='(i,idx) in navList',
                :class='{active:index === idx}',
                @click='chengeIndex(idx,i.id)').stage    {{i.stepName}}
                    Icon(type="ios-arrow-forward" v-if="(idx + 1) !== navList.length").icon
                li.rightButton
                  Icon(style="margin-right:10px;" type=" iconfont icon-fenpei",color='#3A76D2',size='22',@click='handleAddNav' v-if="!!Case.basic.id").icon
                  button.preview(@click='preview') 预览
                  button.Release(@click='Release',v-if="!seeState") {{$role.role==='student'?'提交':'发布'}}
        Modal(v-model="sortVisibel" title='管理导航栏' @on-ok="handleSortOk" @on-cancel="sortVisibel = false")
          div(style="display:flex;margin-bottom:20px;")
            div(style="flex:12") 选项名
            div(style="flex:2") 排序
            div(style="flex:4") 操作
          div(v-for="(item,index) in navListCopy" :key="item.key" style="display:flex;align-items:center;margin-bottom:20px;" :draggable="true" @dragenter="dragenter($event, index)" @dragover="dragover($event)" @dragstart="dragstart(index)")
            Input(v-model="item.stepName" placeholder="请输入" style="width: 300px;" :maxlength="10")
            Icon(type="ios-list" style="margin-left:30px;cursor:pointer;")
            Poptip(confirm title="是否确定删除？" @on-ok="handDelTag(item.id)")
              Icon(type="ios-beaker" style="margin-left:45px;cursor:pointer;")
          Button(type="primary" icon="md-add" @click="handleAddTag") 添加标签
        Modal(v-model="modal1" :footer-hide="true" width="416px").modalsave
          p(slot="header" style="height:52px;padding:10px")
            i(class="icon-gantanhao iconfont" style="color:#F19D38;font-size:28px;")
            span(style="font-size:16px;font-family:MicrosoftYaHeiUI;font-weight:bold;color:rgba(42,46,54,0.8);line-height:20px;margin-left:20px") 是否确定退出当前案例？
          div
            //- 2021年3月2日 改为询问框，不处理。确定按钮之前传save
            //- Button(style="margin-right:130px" @click="gotoback('notsave')") 不保存
            Button(style="border:none;margin-right:15px;margin-left:240px" @click="gotoback('cancel')") 取消
            Button(style="background:#2789F0;color:#fff" @click="gotoback('notsave')") 确定
    router-view(v-if='state' ref="childFun")
    div(v-if="seeState",ref="seize-left",@click="fun_seeState").seize-a-seat-left
      div(ref="box-height-left")
    div(v-if="seeState",ref="seize-right",@click="fun_seeState").seize-a-seat-right
      div(ref="box-height-right")
</template>

<script>
import { mapState } from "vuex";
import mybus from "@/utils/main";
import docase from "@/mixins/case/doCase";
import dayjs from "dayjs";
export default {
  mixins: [docase],
  provide() {
    return {
      seeState: this.seeState,
    };
  },
  data() {
    return {
      sortVisibel: false,
      modal1: false,
      state: true,
      navListCopy: [
        {
          title: "政策制定",
          stepName: "政策制定",
          key: "a",
        },
        {
          title: "政策执行",
          stepName: "政策执行",
          key: "b",
        },
        {
          title: "政策评估",
          stepName: "政策评估",
          key: "c",
        },
        {
          title: "政策终结",
          stepName: "政策终结",
          key: "d",
        },
      ],
      navList: [
        {
          title: "基本信息",
          stepName: "基本信息",
        },
      ],
      url: ["/case", "/case/policy", "/case/policy", "/case/policy", "/case/policy"],
      caseValue: [],
      index: 0,
      seeState: sessionStorage.getItem("SeeState") === "true",
      userInfo: {
        src: "",
        name: "",
        type: "",
      },
      dragIndex: 0,
    };
  },
  watch: {
    // state() {
    //   if (this.state && this.seeState) {
    //     this.$nextTick(() => {
    //       this.$refs.seize.style.height = `${this.$refs.childFun.$el.offsetHeight}px`;
    //     });
    //   }
    // }
  },
  methods: {
    handleAddNav() {
      if (this.seeState) {
        this.$Message.error("查看模式不可编辑！");
        return;
      }
      this.sortVisibel = true;
    },
    setScrollHeight() {
      if (sessionStorage.getItem("SeeState") === "true" && this.index !== 0) {
        setTimeout(() => {
          this.$refs[
            "box-height-left"
          ].style.height = `${this.$refs.childFun.$refs.leftControl.scrollHeight}px`;
          this.$refs[
            "box-height-left"
          ].style.width = `${this.$refs.childFun.$refs.leftControl.clientWidth}px`;
          this.$refs["box-height-right"].style.height = `${
            this.$refs.childFun.$refs["Formulate-content"].scrollHeight + 50
          }px`;
          this.$refs[
            "box-height-right"
          ].style.width = `${this.$refs.childFun.$refs["Formulate-content"].clientWidth}px`;
        }, 1000);
        this.$refs["seize-left"].addEventListener("scroll", (e) => {
          this.$refs.childFun.leftScrollTop = e.target.scrollTop;
        });
        this.$refs["seize-right"].addEventListener("scroll", (e) => {
          this.$refs.childFun.rightScrollTop = e.target.scrollTop;
        });
      }
    },
    handleAddTag() {
      if (this.navListCopy.length > 9) {
        return this.$Message.warning("导航栏最多添加10个！");
      }
      this.navListCopy.push({
        title: "",
        stepName: "",
        key: Math.floor(Math.random() * (99999999999999 - 1 + 1)) + 1,
      });
    },
    async handDelTag(id) {
      try {
        await this.$http.removeCaseHall(id);
        this.$Message.success("删除成功！");
        this.getNavList();
      } catch (error) {
        console.log(error);
      }
      // this.navListCopy = this.navListCopy.filter((val, i) => i !== index);
    },
    dragenter(e, index) {
      e.preventDefault();
      // 避免源对象触发自身的dragenter事件
      if (this.dragIndex !== index) {
        const moving = this.navListCopy[this.dragIndex];
        this.navListCopy.splice(this.dragIndex, 1);
        this.navListCopy.splice(index, 0, moving);
        // 排序变化后目标对象的索引变成源对象的索引
        this.dragIndex = index;
      }
    },
    dragover(e) {
      e.preventDefault();
    },
    dragstart(index) {
      this.dragIndex = index;
    },
    async handleSortOk() {
      try {
        await this.$http.updateCaseHallNavbarList(
          this.Case.basic.id,
          this.navListCopy.map((v, i) => {
            return { ...v, sortNo: i, stepName: v.stepName };
          })
        );
        this.getNavList();
      } catch (error) {
        console.log(error);
      }
      // this.navList.splice(1, 4);
      // this.navList = this.navList.concat(
      //   this.navListCopy.map(v => {
      //     return {
      //       ...v,
      //       title: v.stepName
      //     };
      //   })
      // );
    },
    fun_seeState() {
      this.$Message.error({
        background: true,
        content: "查看模式不可编辑",
      });
    },
    async getNavList() {
      try {
        const { data } = await this.$http.getCaseHallNavbarList(this.Case.basic.id);

        this.navListCopy = data.data || [];
        this.navList = [
          {
            title: "基本信息",
            stepName: "基本信息",
          },
        ].concat(data.data.sort((a, b) => a.sortNo - b.sortNo));
        this.caseValue = data.data.sort((a, b) => a.sortNo - b.sortNo).map((v) => v.caseStep);
      } catch (error) {
        console.log(error);
      }
    },
    getByCode() {
      this.$http
        .userInfo({ code: this.$role.code })
        .then((res) => {
          // 新增对登录账户属性的判断,针对管理员教师学生做出type类型判断
          if (res.data.success) {
            console.log(res);
            this.userInfo.name = res.data.data.name;
            this.userInfo.src = res.data.data.headImagePath;
            if (res.data.data.admin === true) {
              this.userInfo.type = "admin";
              this.query();
            } else if (res.data.data.student === true) {
              this.userInfo.type = "student";
              this.query();
            } else if (res.data.data.teacher === true) {
              this.userInfo.type = "teacher";
              this.query();
            }
            console.log(this.userInfo);
          }
        })
        .catch(() => {
          this.$Message.error("服务器异常");
        });
    },
    preview() {
      const data = {
        pyId: this.$store.state.Case.basic.id,
        userId: this.$role.code,
        members: JSON.stringify([this.$role.code]),
        distribution: this.$store.state.Case.caseValue.join(","),
        viewAnswer: "true",
        viewReport: "false",
        name: "adnasd",
        startTime: dayjs().format("YYYY-MM-DD HH:mm:ss"),
        endTime: dayjs().add(7, "day").format("YYYY-MM-DD HH:mm:ss"),
        createTime: dayjs().format("YYYY-MM-DD HH:mm:ss"),
        adminCreate: false,
        sync: true,
        show: false,
      };
      this.$http.createOrUpdateExperiment(data).then((res) => {
        if (res.data.success) {
          // this.$router.push({
          //   path: "/stuReport",
          //   query: {
          //     usercode: this.$role.code,
          //     experimentid: this.$store.state.doCase.experimentId
          //   }
          // });
          window.location.href = `/policy_stu/?id=${this.Case.basic.id}&experimentId=${res.data.data}`;
        }
      });
      // 预览实验 生成随机数成为分配id
      // const i = Math.floor(Math.random() * (99999999999999 - 1 + 1)) + 1;
      // const data3 = {
      //   caseExperimentId: this.Case.basic.id,
      //   experimentId: i
      // };
      // this.$store.commit("postStuCaseId", data3);

      // this.caseValue.forEach((item, index) => {
      //   const data = {
      //     caseStep: item,
      //     pyId: this.Case.basic.id
      //   };
      //   this.$http.getCasehallByPyIdAndCaseStep(data).then(res => {
      //     console.log(res);
      //     const data1 = {
      //       index: item,
      //       tsId: res.data.data ? res.data.data.id : "",
      //       stageShow: res.data.data ? res.data.data.stageShow : ""
      //     };
      //     this.$store.commit("postStuCaseInformation", data1);
      //     if (index === this.caseValue.length - 1) {
      //       sessionStorage.setItem("doIndex", -1);
      //       sessionStorage.setItem("pageIndex", 0);
      //       sessionStorage.setItem("willDoIndex", 4);
      //       this.$router.push("/preview");
      //     }
      //   });
      // });
    },
    Release() {
      // 发布案例按钮
      const data = new FormData();
      data.append("caseName", this.Case.basic.title);
      data.append("caseTypes", JSON.stringify(this.Case.basic.type));
      data.append("userId", this.$role.code);
      data.append("caseDescription", this.Case.basic.CaseBrief);
      data.append("id", this.Case.basic.id);
      data.append("editorOption", this.Case.basic.stem);
      if (this.$role.role === "student") {
        data.append("classId", sessionStorage.getItem("classId"));
        data.append("isTeacherExp", false);
        data.append("auditStatus", "未审核");
        data.append("teacherExp", false);
      } else {
        data.append("isTeacherExp", true);
        data.append("isPublish", true);
        data.append("teacherExp", true);
        // 上传案例
        const assemblyList = this.$store.state.updateCase.assemblyList;
        const tsId = this.$store.state.updateCase.tsId;
        console.log("assemblyList", assemblyList);
        console.log("tsId", tsId);
        // if (assemblyList) {
        // this.MX_Handle(assemblyList, tsId, null, true);
        // }
      }
      data.append("caseCover", "");
      this.$http.updateCaseExperiment(data).then((res) => {
        console.log(res, "ressssssssss");
        let errMsg = false;
        try {
          // 正常解码 显示原本的信息
          errMsg = JSON.parse(res.data.message).content;
          errMsg = false;
        } catch {
          // 解码错误 直接显示
          errMsg = res.data.message;
        }
        if (res.data.success) {
          if (this.userInfo.type === "admin") {
            this.$Message.success("发布成功");
          }
          if (this.userInfo.type === "teacher") {
            this.$Message.success("发布成功");
          }
          if (this.userInfo.type === "student") {
            this.$Message.success("提交成功");
          }
          this.gotoback("notsave");
        } else if (errMsg) {
          this.$Message.destroy();
          this.$Message.error(errMsg);
        } else {
          this.$Message.destroy();
          const data2 = JSON.parse(res.data.message);
          const title2 = `当前总分为${data2.score}分,需等于100分`;
          // eslint-disable-next-line prefer-template
          const span = data2.caseHallScoreMap
            .split(",")
            .map((v) => v.replace("{", ""))
            .map((v) => `<span>${v.replace("}", "")}</span>`);
          /* eslint-enable */
          // <span v-for="item in data2.caseHallScoreMap.split(",")" :key="item" style='margin-right: 20px;float:left;width:110px'></span>
          const content2 = `<div style='width: 260px;height:60px'>${span}</div>`;
          this.$Modal.error({
            title: title2,
            content: content2,
          });
        }
      });
    },
    gotoback1() {
      if (this.seeState) {
        this.back("notsave");
        return;
      }
      this.modal1 = true;
    },
    gotoback(val) {
      this.modal1 = false;
      setTimeout(() => {
        this.back(val);
      });
    },
    back(val) {
      if (val === "notsave") {
        if (this.$role.role === "student") {
          this.$router.push("/Student/custom-case");
        } else {
          this.$router.push("/Teacher/case");
        }
      } else if (val === "save") {
        console.log(this.$route.path);
        if (this.$route.path === "/case") {
          console.log("1111");
          this.$refs.childFun.fun_upload1();
        } else if (this.$route.path === "/case/policy") {
          console.log(this.$refs.childFun.stepIndex);
          if (this.$refs.childFun.stepIndex === 0) {
            this.$refs.childFun.Sure1();
          } else {
            this.$refs.childFun.taskSure1();
          }
        }
      }
    },
    querylistTaskByChid(id, chId) {
      return new Promise((resolve) => {
        this.$http.getTaskByCategoryId(id, chId).then(async (res) => {
          const { data: value } = await this.$http.getCaseHallNavbarList(this.Case.basic.id);
          const stepValue = value.data.sort((a, b) => a.sortNo - b.sortNo).map((v) => v.caseStep);
          const data2 = {
            index: stepValue[this.index - 1],
            tasklist: res.data.data || [],
          };
          this.$store.commit("postTask", data2 || []);
          resolve(res.data.data);
        });
      });
    },
    queryScene() {
      // 查询大厅下的场景
    },
    async querycaseDepa(id) {
      // 查询部门
      const data = {
        chId: id,
      };
      const res = await this.$http.listCaseDepartmentStepByChid(data);
      const data2 = {
        index: this.caseValue[this.index - 1],
        taskHome: res.data.data,
      };
      console.log("获取部门数据");
      console.log(res);
      this.$store.commit("postcaseHome", data2);
      mybus.$emit(
        "updateHallList",
        data2.taskHome.map((res2) => {
          return {
            name: res2.departmentName,
            id: res2.id,
          };
        })
      );
    },
    async query() {
      this.$Spin.show(); // 👈 显示加载中
      try {
        // 查询大厅
        if (this.index === 0) {
          this.$router.push(this.url[this.index]);
          return;
        }

        const data = {
          pyId: this.Case.basic.id,
          caseStep: this.caseValue[this.index - 1],
        };

        const res = await this.$http.getCasehallByPyIdAndCaseStep(data);

        if (res.data.success) {
          const data2 = {
            index: this.caseValue[this.index - 1],
            id: res.data.data.id,
            stageShow: res.data.data.stageShow,
          };
          this.$store.commit("postHallData", data2);

          await this.querycaseDepa(res.data.data.id); // 👈 等待执行完毕
          this.querycase();
          if (this.$route.path !== "/case/policy") this.$router.push("/case/policy");
        } else {
          this.$store.commit("postHallData", {
            index: this.caseValue[this.index - 1],
            id: "",
            stageShow: "",
          });
          if (this.$route.path !== "/case/policy") this.$router.push("/case/policy");
        }
      } catch (e) {
        console.error("查询失败", e);
      } finally {
        this.$Spin.hide(); // 👈 不论成功/失败都关闭 loading
      }
    },

    async chengeIndex(index, chId) {
      console.log(index);
      console.log(chId, "chi");
      console.log(this.Case.basic.id, "this.Case.basic.id");
      if (index === 1) {
        this.getNavList();
      }
      this.$store.commit(
        "setChId",
        chId || this.navListCopy.sort((a, b) => a.sortNo - b.sortNo)[index].id
      );
      sessionStorage.setItem("chId", chId);
      this.$store.commit("getCaseData", this.Case.basic.id);
      this.$store.commit("getDoCaseData", this.Case.basic.id);
      try {
        this.state = false;
        this.index = index;
        sessionStorage.setItem("CaseStage", index);
        await this.query();
        const { data } = await this.$http.getCategoryAndTaskList(chId);
        console.log(data, "chdata");
        this.$nextTick(() => {
          this.state = true;
        });
      } catch (error) {
        this.$Message.error("暂未开发");
      }
      this.setScrollHeight();
    },
    querycase() {
      const data = {
        id: this.Case.basic.id,
      };
      this.$http.getCaseExperimentById(data).then((res) => {
        console.log(res.data.data);
      });
    },
  },
  mounted() {
    this.index = +sessionStorage.getItem("CaseStage");
    this.query();
    // if (this.seeState) {
    //   this.$nextTick(() => {
    //     this.$refs.seize.style.height = `${this.$refs.childFun.$el.offsetHeight}px`;
    //   });
    // }
    console.log(this.$refs.childFun.$refs, "style");
  },
  computed: mapState({
    // 映射 this.Case 为 store.state.Case
    Case() {
      return this.$store.state.Case;
    },
    doCase() {
      return this.$store.state.doCase;
    },
  }),
  created() {
    if (this.Case.basic.id) {
      this.getNavList();
    }
    this.getByCode();
  },
};
</script>
<style scoped>
.sort {
  width: 30px;
  height: 30px;
  margin-right: 10px;
}
</style>
<style lang="less" scoped>
.seize-a-seat-left,
.seize-a-seat-right::-webkit-scrollbar {
  display: none; /* Chrome, Safari, and Opera */
}
</style>
<style lang="stylus" socped>
.modalsave
  .ivu-modal-wrap
    .ivu-modal
      .ivu-modal-content
        .ivu-modal-header
          border none
.seize-a-seat-right
  position fixed
  height 880px
  top 60px
  right 0
  overflow scroll
  z-index 5
.seize-a-seat-left
  position fixed
  height 880px
  top 60px
  left 0
  overflow scroll
  z-index 5
.index
  background #EEF2F5
  min-height 100vh
  .top-nav1
    position relative
    text-align left
    height 60px
    background rgba(255, 255, 255, 1)
    width 100%
    box-shadow 0px -1px 0px 0px rgba(217, 217, 217, 0.5)
    z-index 88
  .top-nav
    position fixed
    text-align left
    height 60px
    background rgba(255, 255, 255, 1)
    top 0
    width 100%
    box-shadow 0px -1px 0px 0px rgba(217, 217, 217, 0.5)
    z-index 88
    .icon-back
      font-size 24px
      line-height 60px
      padding-left 17px
      color rgba(42, 46, 54, 0.8)
      cursor pointer
      position relative
      z-index 2
    .nav-center
      position absolute
      left 0
      right 0
      margin 0
      line-height 60px
      z-index 1
      text-align center
      display inline-block
      .rightButton
        display inline-flex
        right 32px
        position absolute
        line-height 0
        margin-top 12px
        align-items center
        .preview
          width 100px
          height 36px
          background rgba(255, 255, 255, 1)
          border-radius 4px
          border 1px solid rgba(58, 118, 210, 1)
          font-size 14px
          font-family MicrosoftYaHeiUI
          color rgba(58, 118, 210, 1)
          line-height 18px
          margin-right 16px
          cursor pointer
        .Release
          width 100px
          height 36px
          background rgba(58, 118, 210, 1)
          border-radius 4px
          font-size 14px
          font-family MicrosoftYaHeiUI
          color rgba(255, 255, 255, 1)
          line-height 18px
          border none
          cursor pointer
    .stage
      font-size 14px
      font-family MicrosoftYaHeiUI
      color rgba(42, 46, 54, 0.8)
      display inline-block
      cursor pointer
      .icon
        margin-left 28px
        margin-right 28px
    .active
      color rgba(58, 118, 210, 1)
      position relative
      &::before
        content ''
        position absolute
        left 0
        top 59px
        width 56px
        height 2px
        background-color #3a76d2
</style>
